module.exports = __webpack_public_path__ + "img/google-play.2f9b855.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/google-play.svg
// module id = ./assets/assistant/google-play.svg
// module chunks = 10